export const getFileType = (filename) => {
  const ext = filename.split('.').pop().toLowerCase();
  if (ext === 'pdf') return 'pdf';
  if (ext === 'doc' || ext === 'docx') return 'doc';
  if (ext === 'xls' || ext === 'xlsx') return 'xls';
  if (ext === 'zip') return 'zip';
  if (['jpg', 'jpeg', 'png', 'gif', 'webp'].includes(ext)) return 'image';
  return 'other';
};

export const getFileIcon = (type) => {
  switch (type) {
    case 'pdf':
      return 'mdi-file-pdf-box';
    case 'doc':
    case 'docx':
      return 'mdi-file-word-box';
    case 'xls':
    case 'xlsx':
      return 'mdi-file-excel-box';
    case 'zip':
      return 'mdi-zip-box';
    case 'image':
      return 'mdi-file-image-outline';
    default:
      return 'mdi-file-document';
  }
};

export const getFileTypeColor = (type, variant = 'background') => {
  const colors = {
    pdf: { background: '#fee2e2', icon: '#dc2626' },
    doc: { background: '#dbeafe', icon: '#2563eb' },
    docx: { background: '#dbeafe', icon: '#2563eb' },
    xls: { background: '#dcfce7', icon: '#16a34a' },
    xlsx: { background: '#dcfce7', icon: '#16a34a' },
    zip: { background: '#fef3c7', icon: '#ca8a04' },
    image: { background: '#f3e8ff', icon: '#7c3aed' },
    other: { background: '#f3f4f6', icon: '#6b7280' },
  };

  return colors[type]?.[variant] || colors.other[variant];
};
